import {i18n} from "@lingui/core";

export enum JobType {
    AD = "AD",
    CEO = "CEO",
    FOUNDER = "FOUNDER",
    HEAD_OF_RETAIL = "HEAD_OF_RETAIL",
    COUNTRY_MANAGER = "COUNTRY_MANAGER",
    DEVELOPER = "DEVELOPER",
    LEASING_MANAGER = "LEASING_MANAGER",
}

export class JobTypeTranslations {
    AD = /*i18n*/i18n._({id: "enums.representative-job.AD", message: "AD"})
    CEO = /*i18n*/i18n._({id: "enums.representative-job.CEO", message: "CEO"})
    FOUNDER = /*i18n*/i18n._({id: "enums.representative-job.FOUNDER", message: "Fondatore"})
    HEAD_OF_RETAIL = /*i18n*/i18n._({id: "enums.representative-job.HEAD_OF_RETAIL", message: "Respondabile vendita al dettaglio"})
    COUNTRY_MANAGER = /*i18n*/i18n._({id: "enums.representative-job.COUNTRY_MANAGER", message: "Responsabile locale"})
    DEVELOPER = /*i18n*/i18n._({id: "enums.representative-job.DEVELOPER", message: "Sviluppatore"})
    LEASING_MANAGER = /*i18n*/i18n._({id: "enums.representative-job.LEASING_MANAGER", message: "Responsabile gestore del leasing"})
}

export interface Representative {
    id: string;
    name: string;
    email: string;
    phone: string;
    job: JobType;
    brand: string; //TODO vedere cosa arriva
}
